/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SettingsPayload = {
    properties: {
        MaxHourPerDay: {
    type: 'number',
},
        MaxHourPerWeek: {
    type: 'number',
},
    },
};